import { createApp } from 'vue'
import NewCarLoanCalculatorInput from './NewCarLoanCalculatorInput'
import handleComponentProps from '../../../foundation/js/utils/handleComponentProps.js'

const el = '.nyk-component--new-car-loan-calculator-input'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((NewCarLoanCalculatorInputDOM) => {
            const props = handleComponentProps(NewCarLoanCalculatorInput, NewCarLoanCalculatorInputDOM)
            const component = createApp(NewCarLoanCalculatorInput, props).use(Store)
            component.mount(NewCarLoanCalculatorInputDOM)
        })
    }
}
